(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rt-christmas-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rt-christmas-slider')) {
    customElements.define('rt-christmas-slider', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.track = this.querySelector('.rt-xmas__track');
        this.slides = [...this.querySelectorAll('.rt-xmas__slide')];
        this.current = 0;
        this.querySelector('.rt-xmas__controls')?.removeAttribute('hidden');
        this.querySelectorAll('[data-direction]').forEach(button => button.addEventListener('click', () => this.go(this.current + Number(button.dataset.direction)), options));
        this.track.addEventListener('keydown', event => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this.go(this.current + (event.key === 'ArrowRight' ? 1 : -1));
        }, options);
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.update());
        }, { ...options, passive: true });
        this.resize = new ResizeObserver(() => {
          this.track.scrollTo({ left: this.current * this.track.clientWidth, behavior: 'instant' });
          this.update();
        });
        this.resize.observe(this.track);
        document.addEventListener('shopify:block:select', event => {
          const index = this.slides.findIndex(slide => slide.dataset.slideId === event.detail.blockId);
          if (index !== -1) this.go(index, true);
        }, options);
        this.update();
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.resize?.disconnect();
        cancelAnimationFrame(this.frame);
      }
      go(index, instant = false) {
        const next = (index + this.slides.length) % this.slides.length;
        this.track.scrollTo({ left: next * this.track.clientWidth, behavior: instant || matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }
      update() {
        const index = Math.round(this.track.scrollLeft / Math.max(1, this.track.clientWidth));
        this.current = Math.max(0, Math.min(index, this.slides.length - 1));
        this.slides.forEach((slide, i) => {
          slide.toggleAttribute('inert', i !== this.current);
          slide.setAttribute('aria-hidden', String(i !== this.current));
        });
        const counter = this.querySelector('[data-current]');
        if (counter) counter.textContent = String(this.current + 1).padStart(2, '0');
        const progress = this.querySelector('[data-progress]');
        if (progress) progress.style.width = `${(this.current + 1) / this.slides.length * 100}%`;
        const status = this.querySelector('[data-status]');
        if (status && this.announced !== this.current) {
          if (this.announced !== undefined) status.textContent = `${status.dataset.announcement} ${this.current + 1} / ${this.slides.length}: ${this.slides[this.current].getAttribute('aria-label').split(' — ').slice(1).join(' — ')}`;
          this.announced = this.current;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
